/**
 * Inline icons and the logo mark — inlined so CSS can colour them and
 * GSAP can draw them.
 *
 * @module components/icons
 */

import { html, raw } from '../lib/html.js';

/**
 * The two halves of the logo mark, straight from assets/img/logo/red.svg.
 * The scenes reuse them (the hero's chest, the moon of the finale).
 */
export const MARK_LEFT =
    'M252.08 340.03L195.98 299.09L195.98 233.9L252.08 202.81L252.08 174.77L167.18 220.25L167.18 321L252.08 371.87L252.08 340.03Z';
export const MARK_RIGHT =
    'M266.18 339.03L322.27 298.09L322.27 232.9L266.18 201.81L266.18 173.77L351.08 219.25L351.08 320L266.18 370.87L266.18 339.03Z';

/**
 * The logo mark.
 *
 * @param {string} className - Placement class (brand__mark, loader__mark…).
 * @returns {import('../lib/html.js').Markup}
 */
export function logoMark(className) {
    return html`<svg class="logo-mark ${className}" viewBox="160 166 198 214" aria-hidden="true" focusable="false">
        <path class="logo-mark__left" d="${MARK_LEFT}" />
        <path class="logo-mark__right" d="${MARK_RIGHT}" />
    </svg>`;
}

/** A chevron pointing right. */
export const arrowIcon = () =>
    raw(
        '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' +
            '<polygon points="33.7,95.8 27.8,90.5 63.9,50 27.8,9.5 33.7,4.2 74.6,50"/></svg>',
    );

/** An arrow pointing down. */
export const downArrowIcon = () =>
    raw(
        '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" aria-hidden="true" focusable="false">' +
            '<path d="M12 4v16m0 0l-6-6m6 6l6-6"/></svg>',
    );
